import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/Newsletter.css";

const Newsletter = () => {
  const [title, setTitle] = useState("");
  const [pdf, setPdf] = useState(null);
  const [progress, setProgress] = useState(0);
  const [responseMessage, setResponseMessage] = useState("");
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(
        "https://api.gkaglobal.org/restgka/admin/news.php"
      );
      if (
        response.data.status === "success" &&
        Array.isArray(response.data.files)
      ) {
        setFiles(
          response.data.files.map((file, index) => ({
            id: response.data.ids[index],
            name: file,
            url: `${response.data.baseurl}/${file}`,
          }))
        );
        console.log("Data...", response);
      }
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

  const handleFileChange = (event) => {
    setPdf(event.target.files[0]);
    console.log("event", event);
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!title || !pdf) {
      setResponseMessage("Please provide a valid title and select a PDF file.");
      return;
    }
    setResponseMessage("");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("pdf", pdf);

    try {
      const response = await axios.post(
        "https://api.gkaglobal.org/restgka/admin/unews.php",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percentComplete = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            setProgress(percentComplete);
          },
        }
      );

      console.log("Upload Response:", response.data);

      if (response.data.status) {
        setTitle("");
        setPdf(null);
        setProgress(0);
        fetchNotifications();
        setResponseMessage(response.data.message);
      }
    } catch (error) {
      setResponseMessage("Error uploading file");
      console.error("Upload error:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;
    try {
      const response = await axios.post(
        "https://api.gkaglobal.org/restgka/admin/dnews.php",
        JSON.stringify({ id }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("Delete Response:", response.data);

      if (response.data.status === "success") {
        fetchNotifications();
        alert("File deleted successfully");

        setFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));
      } else {
        alert("Failed to delete file");
      }
    } catch (error) {
      alert("Error deleting file");
      console.error("Delete error:", error);
    }
  };

  return (
    <div className="container1 ">
      <h2 className="text-center1">Upload PDF For GKA News Letter</h2>
      <form
        onSubmit={handleUpload}
        className="border p-4 bg-light shadow rounded"
      >
        <div className="mb-3">
          <label className="form-label1">Title:</label>
          <input
            type="text"
            className="form-control1"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">PDF File:</label>
          <input
            type="file"
            className="form-control1"
            accept="application/pdf"
            onChange={handleFileChange}
            required
          />
        </div>
        <div className="progress1 mb-3">
          <div
            className="progress-bar1 progress-bar-striped1"
            style={{ width: `${progress}%` }}
          >
            {progress}%
          </div>
        </div>
        <button type="submit" className="btn1 btn-primary w-100">
          Upload
        </button>
      </form>
      {responseMessage && (
        <div className="mt-3 text-center1 text-success1">{responseMessage}</div>
      )}

      <h2 className="mt-5 text-center">News Letter</h2>
      <div className="table-responsive1">
        <table className="table1 table-bordered1 mt-3">
          <thead>
            <tr>
              <th>#</th>
              <th>PDF</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {files.length > 0 ? (
              files.map((file, index) => (
                <tr key={file.id}>
                  <td>{index + 1}</td>
                  <td>
                    <a
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {file.name}
                    </a>
                  </td>
                  <td>
                    <button
                      className="btn2 btn-danger"
                      onClick={() => handleDelete(file.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center2">
                  No files found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Newsletter;
